import React from 'react';
import { SuggestionItem } from './suggestion-item/suggestion-item';
import { Divider } from '@placer-ui/components';

type SuggestionsListProps = {
    suggestions: string[];
    input?: string;
    onSuggestionClick: (suggestion: string) => void;
};

export const SuggestionsList = ({
    suggestions,
    input,
    onSuggestionClick,
}: SuggestionsListProps) => {
    return (
        <div>
            {suggestions.map((suggestion, index) => (
                <span key={index} data-testid={`suggestion-${index}`}>
                    <SuggestionItem
                        text={suggestion}
                        input={input}
                        onClick={() => onSuggestionClick(suggestion)}
                    />
                    <Divider />
                </span>
            ))}
        </div>
    );
};
